import axios from "axios";

class BaseApi {
  constructor(baseUrl, tokenKey, tokenExpirationKey) {
    this.baseUrl = baseUrl;
    this.tokenKey = tokenKey;
    this.tokenExpirationKey = tokenExpirationKey;

    this.formEncoded = {
      withCredentials: true,
      baseURL: this.baseUrl,
      timeout: 30000,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    this.jsonEncoded = {
      withCredentials: true,
      baseURL: this.baseUrl,
      timeout: 30000,
      headers: {
        "Content-Type": "application/json",
      },
    };
    this.multiPartEncoded = {
      withCredentials: true,
      baseURL: this.baseUrl,
      timeout: 30000,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    this.useToken = true;
    this.instance = axios.create(this.jsonEncoded);

    this.instance.interceptors.request.use(
      async (config) => {
        if (this.useToken) {
          const authToken = this.getCurrentValidToken(
            this.tokenKey,
            this.tokenExpirationKey
          );
          if (authToken) {
            config.headers.Authorization = "Bearer " + authToken;
          } else {
            console.log(
              "BaseApi: Invoking a request expecting to send a bearer token but no valid token exists."
            );
          }
        }
        return config;
      },
      (err) => {
        return Promise.reject(err);
      }
    );
    this.getAxios = this.getAxios.bind(this);
    this.getCurrentValidToken = this.getCurrentValidToken.bind(this);
  }

  getAxios() {
    return this.instance;
  }

  getCurrentValidToken(tokenKey, tokenExpirationKey) {
    const tokenExpiration = window.localStorage.getItem(tokenExpirationKey);
    if (!tokenExpiration) {
      return null;
    }
    if (Date.now() + 5000 > tokenExpiration) {
      return null;
    }
    const token = window.localStorage.getItem(tokenKey);
    if (!token) {
      return null;
    }
    return token;
  }
}

export default BaseApi;
